<template>
  <level-formulae
    :level-formulae="levelFormulae"
    :entities-by-id="entitiesById"
    :is-loading="isLoading"
    @reload="onReload"
  />
</template>

<script>
import { keyBy } from 'lodash';
import { API } from '@/utils/api';
import { LevelFormulae } from '../components';
const LIST_FORMULAE = '/$v/level_formulae/list.json';
const ENTITY_LIST = '/users/entity_list.json';

export default {
  components: {
    LevelFormulae
  },
  data() {
    return {
      levelFormulae: [],
      entitiesById: {},
      isLoading: false,
    }
  },
  mounted() {
    this.isLoading = true;
    // Required to be in this order for the table not to produce errors
    this.loadEntities().then(this.loadFormulae).finally(() => this.isLoading = false);
  },
  methods: {
    loadFormulae() {
      return API.call(LIST_FORMULAE).then(r => this.levelFormulae = r.data);
    },

    onReload() {
      this.isLoading = true;
      this.loadFormulae().finally(() => this.isLoading = false)
    },

    loadEntities () {
      return API.call(ENTITY_LIST, { with_base: 1 }).then(r => this.entitiesById = keyBy(r.data, 'value'))
    }
  }
}
</script>
